import React from 'react';
import CreatePartyPage from './Page/CreateParty';
import EditPartyPage from './Page/EditParty';
import PartiesPage from './Page/Parties';

export * from './Types/partyTypes';
export { partiesApi } from './Service/partiesApi';

export { default as PartyForm } from './Components/PartyForm/PartyForm';
export { default as PartiesPageView } from './Page/Parties';
export { default as CreatePartyPageView } from './Page/CreateParty';
export { default as EditPartyPageView } from './Page/EditParty';

export const Parties = () => <PartiesPage />;

export const CreateParty = () => <CreatePartyPage />;

export const EditParty = () => <EditPartyPage />;
